
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visuals",
      function () {
        return require("private-next-pages/visuals.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visuals"])
      });
    }
  